var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M143.627 253.984c-7.966.015-15.466.156-22.96-.012-19.14-.428-36.854-6.233-53.391-15.428a118.275 118.275 0 0 1-24.245-17.873c-16.943-16.173-28.696-35.325-35.03-57.86-4.732-16.843-4.883-33.903-3.063-51.157 2.258-21.41 10.386-40.504 23.145-57.502 16.533-22.028 37.949-37.175 64.59-45.377 16.27-5.01 32.697-5.497 49.178-4.56 17.368.986 33.802 6.549 48.91 15.235 8.707 5.005 16.866 10.868 24.23 17.902 16.937 16.176 28.694 35.322 35.012 57.868 4.72 16.847 4.876 33.903 3.059 51.158-2.256 21.412-10.393 40.511-23.155 57.496-16.538 22.013-37.838 37.537-64.635 45.285-7.01 2.027-14.159 3.043-21.645 4.825z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M80 68c0-8.162.182-15.83-.086-23.483-.114-3.241.992-3.798 3.931-3.753 10.991.17 21.99.243 32.977-.03 3.66-.09 4.265 1.084 4.256 4.448-.119 42.474.008 84.949-.203 127.422-.022 4.559 1.25 5.388 5.494 5.334 18.82-.243 37.644.01 56.464-.197 4.073-.044 5.188 1.325 5.072 5.174a394.113 394.113 0 0 0-.008 22.982c.12 4.266-1.013 6.072-5.782 6.042-32.312-.198-64.627-.224-96.939.031-4.676.037-5.28-1.437-5.266-5.554.143-45.972.09-91.944.09-138.416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanL);
export default __webpack_public_path__ + "static/media/icon_plan_L.b9a51ff255a15e54f48fd658fe957a63.svg";
export { ForwardRef as ReactComponent };